import { takeLatest } from 'redux-saga/effects';

import { DELETE_EMPLOYEE, EMPLOYEE_PUBLISH, GET_EMPLOYEE, GET_EMPLOYEE_FIELD_VALUE, RESIGN_EMPLOYEE, GET_BRANCHES, GET_DEPARTMENTS, GET_DESIGNATIONS, GET_EMPLOYEE_CATEGORIES, GET_GENDERS, GET_SHIFTS } from '../../redux.actionTypes';
import deleteEmployeeWorker from './deleteEmployeeWorker';
import employeePublishWorker from './employeePublishWorker';
import getEmployeeWorker from './getEmployeeWorker';
import getSingleFieldValueWorker from './getSingleFieldValueWorker';
import resignEmployeeWorker from './resignEmployeeWorker';
import getBranchesWorker from './getBranchesWorker';
import getDepartmentsWorker from './getDepartmentsWorker';
import getDesignationsWorker from './getDesignationsWorker';
import getEmployeeCategoriesWorker from './getEmployeeCategoriesWorker';
import getGendersWorker from './getGendersWorker';
import getShiftsWorker from './getShiftsWorker';

// Workers

// Watchers
export default function* () {
    yield takeLatest(EMPLOYEE_PUBLISH, employeePublishWorker);
    yield takeLatest(GET_EMPLOYEE, getEmployeeWorker);
    yield takeLatest(DELETE_EMPLOYEE, deleteEmployeeWorker);
    yield takeLatest(GET_EMPLOYEE_FIELD_VALUE, getSingleFieldValueWorker);
    yield takeLatest(RESIGN_EMPLOYEE, resignEmployeeWorker);
    yield takeLatest(GET_BRANCHES, getBranchesWorker);
    yield takeLatest(GET_DEPARTMENTS, getDepartmentsWorker);
    yield takeLatest(GET_DESIGNATIONS, getDesignationsWorker);
    yield takeLatest(GET_EMPLOYEE_CATEGORIES, getEmployeeCategoriesWorker);
    yield takeLatest(GET_GENDERS, getGendersWorker);
    yield takeLatest(GET_SHIFTS, getShiftsWorker);
}
